import { useMemo, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import DoneOutlineIcon from '@/components/assets/DoneOutlineIcon'
import NotInterestedIcon from '@/components/assets/NotInterestedIcon'
import CSI from '@/components/CSI'
import { AccordionItem, AccordionItemTrigger, AccordionRoot } from '@/components/ui/accordion'
import { Box } from '@/components/ui/box'
import { Flex } from '@/components/ui/flex'
import { Link } from '@/components/ui/link'
import { Text } from '@/components/ui/typography'

const SectionDescription = () => {
    const { t } = useTranslation()
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const value = t('chat.translate.sectionDescriptionTitle')
    const accordionValue = useMemo(() => (isOpen ? [value] : []), [isOpen, value])

    return (
        <Box py="24px" width="100%" position="relative">
            <AccordionRoot multiple value={accordionValue}>
                <AccordionItem border="none" value={value}>
                    <AccordionItemTrigger
                        onClick={() => {
                            setIsOpen(!isOpen)
                        }}
                        _hover={{
                            background: 'transparent',
                        }}
                        alignItems="flex-start"
                        p="0"
                        justifyContent="space-between"
                    >
                        <Box display="flex" mt="4px">
                            <Box>
                                <Text
                                    fontSize="12px"
                                    fontFamily="GSKPrecision-Bold"
                                    letterSpacing="0.5px"
                                    textAlign="left"
                                    hidden={isOpen}
                                    as="div"
                                >
                                    <CSI />
                                </Text>
                                <Text fontSize="12px" letterSpacing="0.5px" lineHeight="16px" textAlign="left" hidden={!isOpen} as="div">
                                    <Trans
                                        i18nKey={'global.csi.descriptions.translationMode.onDocumentUpload.long'}
                                        components={{
                                            bold: <b />,
                                            br: <br />,
                                            text: <Text fontSize="12px" letterSpacing="0.5px" />,
                                            flex: <Flex mt="12px" fontSize="12px" />,
                                            noIcon: (
                                                <NotInterestedIcon
                                                    color="var(--chakra-colors-status-error)"
                                                    style={{ width: '13px', height: '18px', marginRight: '8px' }}
                                                />
                                            ),
                                            yesIcon: (
                                                <DoneOutlineIcon
                                                    color="var(--chakra-colors-status-success)"
                                                    style={{ width: '13px', height: '18px', marginRight: '8px' }}
                                                />
                                            ),
                                            link1: (
                                                <Link
                                                    href="https://myconnect.gsk.com/sites/modern-InfoProtect#/sitepages/GSK-4-CATEGORIES-OF-INFORMATION.aspx"
                                                    isExternal
                                                    key="https://myconnect.gsk.com/sites/modern-InfoProtect#/sitepages/GSK-4-CATEGORIES-OF-INFORMATION.aspx"
                                                    textDecoration="underline"
                                                />
                                            ),
                                            link2: (
                                                <Link
                                                    href="https://myconnect.gsk.com/sites/modern-privacy#/sitepages/CLASSIFICATION-VS-CATEGORISATION.aspx"
                                                    isExternal
                                                    key="https://myconnect.gsk.com/sites/modern-privacy#/sitepages/CLASSIFICATION-VS-CATEGORISATION.aspx"
                                                    textDecoration="underline"
                                                />
                                            ),
                                        }}
                                    />
                                </Text>
                            </Box>
                        </Box>
                    </AccordionItemTrigger>
                </AccordionItem>
            </AccordionRoot>
        </Box>
    )
}

export default SectionDescription
